import React, { useState, useEffect } from "react";
import '../styles/Test2.css';

function Test2 () {
  

  return (
    <div>Hola2</div>
  );
};

export default Test2;